var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.popover
        ? _c(
            "el-popover",
            { attrs: { placement: "left", width: "380", trigger: "hover" } },
            [
              _c("DiagnosticContent", {
                attrs: {
                  timestamp: _vm.reportTimeStamp,
                  fields: _vm.diagnostic,
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { padding: "0" },
                  attrs: {
                    slot: "reference",
                    type: "text",
                    disabled: !_vm.found,
                  },
                  slot: "reference",
                },
                [
                  _c("span", { class: _vm.textCss }, [
                    _vm._v(_vm._s(_vm.btnText)),
                  ]),
                ]
              ),
            ],
            1
          )
        : _c("DiagnosticContent", {
            attrs: { timestamp: _vm.reportTimeStamp, fields: _vm.diagnostic },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }